import React from 'react';

import bg from '../images/bg.jpg'

const BlockHome = () => {
    return (
        <section className="blockhome" id="home" style={{backgroundImage:`url(${bg})`}}>
            <div className="blockhome_overlay">
               <div className="blockhome_content">
                   <h2 className="blockhome_content_heading">
                       Find Vulnerabilities before the bad guys do.
                   </h2>
               </div>
            </div>
        </section>
    )
};

export default BlockHome;